// extracted by mini-css-extract-plugin
module.exports = {"header":"StoreHeader_header__2C8yp","title":"StoreHeader_title__2zEfO","result":"StoreHeader_result__3M6p_"};